import { useNewAgent } from "../../contexts/NewAgentContext";
import { useTranslation } from "hooks/useTranslation";
import PureDropDown from "components/pure-dropdown";
import ScheduleConfiguration from "components/schedule/schedule-configuration";
import { AUTONOMOUS_AGENT_STATUS } from "../../../../../../constants/agents";

const Trigger = () => {
  const { formData, setFormData } = useNewAgent();
  const { t } = useTranslation();

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <div className="flex flex-col gap-4">
        <PureDropDown
          label={t("agents.newAgent.triggerType")}
          options={[
            {
              value: AUTONOMOUS_AGENT_STATUS.SCHEDULING,
              label: t("agents.newAgent.triggerTypes.schedule"),
            },
            {
              value: AUTONOMOUS_AGENT_STATUS.API_TRIGGER,
              label: t("agents.newAgent.triggerTypes.API_Trigger"),
            },
          ]}
          value={formData.trigger_type || undefined}
          onChange={(value) => {
            const triggerValue =
              value === "" || value === null ? null : (value as string);
            setFormData({
              ...formData,
              trigger_type: triggerValue,
              // Clear cron when trigger type is cleared
              cron: triggerValue === null ? null : formData.cron,
            });
          }}
          placeholder={t("agents.newAgent.selectTriggerType")}
          showClearButton={true}
          onClear={() =>
            setFormData({ ...formData, trigger_type: null, cron: null })
          }
          className="w-full"
          buttonClassName="rounded-xl border border-gray-200 bg-white/0 px-3 py-3 text-sm text-gray-900 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-500 dark:border-white/10 dark:bg-white/0 dark:text-white dark:hover:border-white/20"
        />

        {formData.trigger_type === AUTONOMOUS_AGENT_STATUS.SCHEDULING && (
          <ScheduleConfiguration
            value={formData.cron || ""}
            onChange={(value) => setFormData({ ...formData, cron: value })}
          />
        )}
      </div>
    </div>
  );
};

export default Trigger;
